import { render } from "./ReportsPageTableColumnStatus.vue?vue&type=template&id=3afb3cc5&ts=true"
import script from "./ReportsPageTableColumnStatus.vue?vue&type=script&lang=ts"
export * from "./ReportsPageTableColumnStatus.vue?vue&type=script&lang=ts"

import "./ReportsPageTableColumnStatus.vue?vue&type=style&index=0&id=3afb3cc5&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__